import { gql } from '@apollo/client';

const TABLE_FIELDS = `
  id
  schemaId
  schemaName
  tableName
  description
  purpose
  primaryKeyColumns
  keywords
  businessContext
  createdAt
  createdBy
  updatedAt
  updatedBy
`;

export const GET_RELATIONSHIPS_LIST = gql`
  query TableRelationships($params: FindRelationshipListInput!) {
    tableRelationships(params: $params) {
      success
      message
      errors
      data {
        relationships {
          id
          sourceTableId
          targetTableId
          targetTable {
            ${TABLE_FIELDS}
          }
          joinCondition
          relationshipType
          description
          businessContext
          isIdentifying
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_RELATIONSHIP = gql`
  query TableRelationship($params: FindRelationshipInput!) {
    tableRelationship(params: $params) {
      success
      message
      errors
      data {
        id
        sourceTableId
        targetTableId
        targetTable {
          ${TABLE_FIELDS}
        }
        joinCondition
        relationshipType
        description
        businessContext
        isIdentifying
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
